window.$ = window.jQuery;

$.fn.modal = function(options) {
  const defaults = {};

  options = $.extend({}, defaults, options);

  const $elem = $(this);

  const functions = {
    show() {
      $elem.addClass("visible");
      setTimeout(() => {
        $elem.addClass("modal-animation-in");
      }, 30);
    },

    hide() {
      $elem.removeClass("modal-animation-in").addClass("modal-animation-out");
      setTimeout(() => {
        $elem.removeClass("visible");
      }, 400);
    },

    showLoader() {
      $elem.find(".modal-content .lds-ellipsis").remove();
      $elem
        .find(".modal-content")
        .append(
          '<div class="center center-loader"><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div></div>'
        );
    },

    hideLoader() {
      $elem.find(".modal-content .center-loader").remove();
    }
  };

  if (!$elem.data("modal-initialized")) {
    $elem.data("modal-initialized", true);

    $elem.add($(".modal-close", $elem)).click(function(event) {
      if (
        (!$(event.target).is(".modal-close") &&
          ($(event.target).is(".modal-body") ||
            $(event.target).parents(".modal-body").length > 0)) ||
        $(event.target).is(".regular-login-modal")
      ) {
        return;
      }

      $elem.find(".modal-body iframe").attr("src", "");
      functions.hide();
    });
    $elem.find(".modal-body").click(function(e) {
      e.stopPropagation();
    });
  }

  return functions;
};

export function createModal(className = "") {
  return $(`
    <div class="modal ${className}">
      <div class="modal-body">
        <div class="modal-scroll">
          <div class="modal-close"></div>
          <div class="modal-content"></div>
        </div>
      </div>
    </div>
  `);
}
